import React from 'react';
import { ListItemIcon, Typography } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { useTranslation } from 'react-i18next';
import { themeColors } from '../../constants';
import { IRouteProps } from '../../types';

export default function MuiMenuWelcome(props: IRouteProps) {
  const { t } = useTranslation();
  return (
    <div style={props.isActive ? { color: themeColors.yellow } : {}}>
      <ListItemIcon>
        <InfoIcon fontSize="small" />
      </ListItemIcon>
      <Typography variant="inherit">{t('navigation.welcome')}</Typography>
    </div>
  );
}
